import React, { Component } from "react";

/**
 * On ChunkLoadError (stale mix watch / deploy), reload once so entry + chunks match.
 */
export default class ChunkErrorBoundary extends Component {
    componentDidCatch(error) {
        const isChunkError =
            error?.name === "ChunkLoadError" ||
            /Loading chunk [\w-]+ failed/i.test(error?.message || "");

        if (!isChunkError) return;

        const key = "clk-chunk-reload";
        if (!sessionStorage.getItem(key)) {
            sessionStorage.setItem(key, "1");
            window.location.reload();
        }
    }

    render() {
        return this.props.children;
    }
}
